import styled, { css } from 'styled-components';
import {
  ellipsisText,
  FlexCenterAligned,
  FlexibleDiv
} from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';

export const LocationInfoContainer = styled(FlexibleDiv)`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    position: absolute;
    z-index: 3;
    gap: 20px;
    top: 20px;
    left: 20px;
  }
`;

export const InfoItemText = styled(Typography)`
  color: ${({ theme }) => theme.colors.background.primary};
  ${ellipsisText};
`;

export const InfoItem = styled(FlexCenterAligned)<{
  $isLocation?: boolean;
}>`
  height: 38px;
  padding: 0 15px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 29px;
  transition: all 0.2s ease-in-out;
  gap: 10px;

  path {
    fill: ${({ theme }) => theme.colors.background.primary};
    transition: fill 0.2s ease-in-out;
  }

  svg {
    flex: 0 0 auto;
  }

  ${({ $isLocation }) =>
    $isLocation &&
    css`
      max-width: 400px;

      @media (hover: hover) {
        &:hover {
          cursor: pointer;
          background: rgba(250, 250, 250, 0.25);

          path {
            fill: ${({ theme }) => theme.colors.systemColors.blue};
          }

          ${InfoItemText} {
            color: ${({ theme }) => theme.colors.systemColors.blue};
          }
        }
      }
    `}
`;
